import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineDashboard, MdSettings, MdOutlineCancel, MdNetworkCell, MdAccountBalanceWallet, MdScheduleSend } from 'react-icons/md';
import { FaUsers, FaFileCsv, FaCode } from 'react-icons/fa';
import { IoStatsChart } from "react-icons/io5";
import { useStateContext } from '../Context/ContextProvider';
import 'tw-elements';
import axios from '../../api/api'

const SideBar = () => {
  const { activeMenu, setActiveMenu } = useStateContext();

  const sidebarRef = useRef(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close sidebar when clicking outside of it on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setActiveMenu(false);
      }
    };

    if (isMobile && activeMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeMenu, isMobile, setActiveMenu]);

  // user details
  const currentUser = window.localStorage.getItem('token');
  const user = JSON.parse(currentUser).data.user_data;

  // user accounts balances
  const [account, setAccount] = useState([]);

  useEffect(() => {
    const getAccounts = async () => {
      try {
        const response = await axios.get('/service_clients/')
        setAccount(response.data.items)
      } catch (error) {
        console.log(error)
      }
    }
    getAccounts()
  },[])

  const airtimeBalance = account.find((el) => el.is_live === 1 && el.service_ref_id === 2)?.units ?? 0
  const dataBalance = account.find((el) => el.is_live === 1 && el.service_ref_id === 5)?.units ?? 0

  return (
    <main className='bg-[#0b293b] text-white h-screen md:overflow-hidden relative overflow-auto md:hover:overflow-auto pb-10'>
      {activeMenu && (
        <>
          <div className='flex justify-between items-center relative px-4 lg:py-3.5 2xl:py-5 font-sans font-bold border-b border-b-[#7987a1]'>
            <h3>Credo <span className='text-yellow-500'>Faster</span></h3>
            <div className='text-xl rounded-full hover:bg-light-gray block md:hidden'>
              <button onClick={() => setActiveMenu(!activeMenu)}><MdOutlineCancel /></button>
            </div>
          </div>
          <div className='flex items-center justify-evenly p-4'>
            <div>
              <div className='bg-[#BDBDBD] h-20 w-20  rounded-full text-2xl flex items-center justify-center'><span>{user.first_name[0]}{user.last_name[0]}</span></div>
            </div>
            <div className='space-y-0.5'>
              <p><b>{user.first_name} {user.last_name}</b></p>
              <p>{user.company}</p>
              <div>
                <p>{airtimeBalance?.toLocaleString()} Airtime</p>
                <p>{dataBalance?.toLocaleString()} Data</p>
              </div>
            </div>
          </div>
          <nav>
            <div className='overflow-y-auto'>
              <div id='sidenavSecExample'>
                <ul className='relative px-1'>
                  <li className='relative'>
                    <Link to='/app/dashboard' className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>
                      <span className='w-4 h-4 mr-3'><MdOutlineDashboard /></span>
                      <span>DashBoard</span>
                    </Link>
                  </li>
                  {user.role === 'CLIENT' && (
                    <li className='relative' id='sidenavXxEx1'>
                      <span className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer' data-mdb-ripple='true' data-mdb-ripple-color='primary' data-bs-toggle='collapse' data-bs-target='#collapseSidenavXxEx1' aria-expanded='false' aria-controls='collapseSidenavXxEx1'>
                        <span className='w-4 h-4 mr-3'><FaUsers /></span>
                        <span>Users</span>
                        <svg aria-hidden='true' focusable='false' data-prefix='fas' className='w-3 h-3 ml-auto' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                          <path fill='currentColor' d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z' />
                        </svg>
                      </span>
                      <ul className='relative accordion-collapse collapse' id='collapseSidenavXxEx1' aria-labelledby='sidenavXxEx1' data-bs-parent='#sidenavSecExample'>
                        <li className='relative'>
                          <Link to='/app/users' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Users</Link>
                        </li>
                        <li className='relative'>
                          <Link to='/app/adduser' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Add User</Link>
                        </li>
                      </ul>
                    </li>
                  )}
                  <li className='relative' id='sidenavXxEx2'>
                    <span className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer' data-mdb-ripple='true' data-mdb-ripple-color='primary' data-bs-toggle='collapse' data-bs-target='#collapseSidenavXxEx2' aria-expanded='false' aria-controls='collapseSidenavXxEx2'>
                      <span className='w-4 h-4 mr-3'><MdNetworkCell /></span>
                      <span>Airtime</span>
                      <svg aria-hidden='true' focusable='false' data-prefix='fas' className='w-3 h-3 ml-auto' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                        <path fill='currentColor' d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z' />
                      </svg>
                    </span>
                    <ul className='relative accordion-collapse collapse' id='collapseSidenavXxEx2' aria-labelledby='sidenavXxEx2' data-bs-parent='#sidenavSecExample'>
                      <li className='relative'>
                        <Link to='/app/buyairtime' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Buy Airtime</Link>
                      </li>
                      <li className='relative'>
                        <Link to='/app/airtime' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Airtime Requests</Link>
                      </li>
                      <li className='relative'>
                        <Link to='/app/buybundle' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Buy Bundle</Link>
                      </li>
                      <li className='relative'>
                        <Link to='/app/bundle' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Bundle Requests</Link>
                      </li>
                      <li className='relative'>
                        <Link to='/app/buyviaexcel' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Buy Via Excel</Link>
                      </li>
                    </ul>
                  </li>
                  <li className='relative' id='sidenavXxEx5'>
                    <span className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer' data-mdb-ripple='true' data-mdb-ripple-color='primary' data-bs-toggle='collapse' data-bs-target='#collapseSidenavXxEx5' aria-expanded='false' aria-controls='collapseSidenavXxEx5'>
                      <span className='w-4 h-4 mr-3'><MdScheduleSend /></span>
                      <span>Schedule Airtime</span>
                      <svg aria-hidden='true' focusable='false' data-prefix='fas' className='w-3 h-3 ml-auto' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                        <path fill='currentColor' d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z' />
                      </svg>
                    </span>
                    <ul className='relative accordion-collapse collapse' id='collapseSidenavXxEx5' aria-labelledby='sidenavXxEx5' data-bs-parent='#sidenavSecExample'>
                      <li className='relative'>
                        <Link to='/app/scheduleairtime' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Schedule Airtime</Link>
                      </li>
                      <li className='relative'>
                        <Link to='/app/schedulebundle' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Schedule Bundle</Link>
                      </li>
                      <li className='relative'>
                        <Link to='/app/scheduleviaexcel' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Schedule Via Excel</Link>
                      </li>
                    </ul>
                  </li>
                  <li className='relative' id='sidenavXxEx4'>
                    <span className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer' data-mdb-ripple='true' data-mdb-ripple-color='primary' data-bs-toggle='collapse' data-bs-target='#collapseSidenavXxEx4' aria-expanded='false' aria-controls='collapseSidenavXxEx4'>
                      <span className='w-4 h-4 mr-3'><FaFileCsv /></span>
                      <span>Reports</span>
                      <svg aria-hidden='true' focusable='false' data-prefix='fas' className='w-3 h-3 ml-auto' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                        <path fill='currentColor' d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z' />
                      </svg>
                    </span>
                    <ul className='relative accordion-collapse collapse' id='collapseSidenavXxEx4' aria-labelledby='sidenavXxEx4' data-bs-parent='#sidenavSecExample'>
                      <li className='relative'>
                        <Link to='/app/successfulreports' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Successful Requests</Link>
                      </li>
                      <li className='relative'>
                        <Link to='/app/pendingreports' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Failed Requests</Link>
                      </li>
                    </ul>
                  </li>
                  {(user.role === 'CLIENT' || user.role === 'ADMIN') && (
                    <>
                      <li className='relative' id='sidenavXxEx3'>
                        <span className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer' data-mdb-ripple='true' data-mdb-ripple-color='primary' data-bs-toggle='collapse' data-bs-target='#collapseSidenavXxEx3' aria-expanded='false' aria-controls='collapseSidenavXxEx3'>
                          <span className='w-4 h-4 mr-3'><MdAccountBalanceWallet /></span>
                          <span>Top Up</span>
                          <svg aria-hidden='true' focusable='false' data-prefix='fas' className='w-3 h-3 ml-auto' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                            <path fill='currentColor' d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z' />
                          </svg>
                        </span>
                        <ul className='relative accordion-collapse collapse' id='collapseSidenavXxEx3' aria-labelledby='sidenavXxEx3' data-bs-parent='#sidenavSecExample'>
                          <li className='relative'>
                            <Link to='/app/topups' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Top Ups</Link>
                          </li>
                          <li className='relative'>
                            <Link to='/app/transactions' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Bank Transactions</Link>
                          </li>
                          <li className='relative'>
                            <Link to='/app/mpesa-transactions' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Mpesa Transactions</Link>
                          </li>
                        </ul>
                      </li>
                      <li className='relative'>
                        <Link to='/app/accounts' className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>
                          <span className='w-4 h-4 mr-3'><MdSettings /></span>
                          <span>My Accounts</span>
                        </Link>
                      </li>
                      <li className='relative'>
                        <Link to='/app/utilization' className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>
                          <span className='w-4 h-4 mr-3'><IoStatsChart /></span>
                          <span>Utilization</span>
                        </Link>
                      </li>
                      <li className='relative'>
                        <a href='https://corporateapi.credofaster.co.ke/api/docs' target="_blank" rel="noreferrer" className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#165277] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>
                          <span className='w-4 h-4 mr-3'><FaCode /></span>
                          <span>Apis</span>
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </div>
          </nav>
        </>
      )}
    </main>
  );
};

export default SideBar;
